// extracted by mini-css-extract-plugin
export default {"NavBar":"NavBar_NavBar__U9XiD"};